import {async} from 'regenerator-runtime'
import {API_URL, RES_PER_PAGE, KEY} from './config.js';
import {AJAX} from './helpers.js';

export const state = {
  recipe: {},
  search: {
    query: ``,
    results: [],
    page: 1,
    resultsPerPage: RES_PER_PAGE,
  },
  bookmarks: []
}

const createRecipeObject = function (data) {
  const {recipe} = data.data;
    return {
      id: recipe.id,
      title: recipe.title,
      publisher: recipe.publisher,
      sourceUrl: recipe.source_url,
      image: recipe.image_url,
      servings: recipe.servings,
      cookingTime: recipe.cooking_time,
      ingredients: recipe.ingredients,
      ...(recipe.key && {key: recipe.key}),
    } 
}
export const loadRecipe = async function(id) {
  try {
    const data = await AJAX(`${API_URL}${id}?key=${KEY}`);

    state.recipe = createRecipeObject(data);
    if(state.bookmarks.some( bookmark => bookmark.id === id)) state.recipe.bookmarked = true;
    else state.recipe.bookmarked = false;
    console.log(state.recipe);
    
  } catch(err) {
    console.log(`${err} 🎇🎇🎇`);
  }
};

export const loadSearchResults = async function(query) {
  try {
    state.search.query = query;
    const data = await AJAX(`${API_URL}?search=${query}&key=${KEY}`);
    state.search.results = data.data.recipes.map(rec => {
      return {
        id: rec.id,
        title: rec.title,
        publisher: rec.publisher,
        image: rec.image_url,
        ...(rec.key && {key: rec.key}),
      }
    })
    state.search.page = 1;
  } catch(err) {
    console.log(`${err} 🎇🎇🎇`);
  }
}

export const getSearchResultsPage = function(page = state.search.page) {
  state.search.page = page;
  const start = (page - 1)*10;
  const end = page*10;
  return state.search.results.slice(start,end);
}

export const updateServings = function(newServings) {
  state.recipe.ingredients.forEach(ing => {
    // newQnt = oldQnt*newServings/oldServings
    ing.quantity = (ing.quantity*newServings) / state.recipe.servings; 
  });
  state.recipe.servings = newServings;
}

const persistBookmarks = function() {
  localStorage.setItem(`bookmarks`,JSON.stringify(state.bookmarks))
}

export const addBookmarks = function(recipe) {
  // add bookmark
  state.bookmarks.push(recipe)

  // mark current recipe as bookmark
  if(recipe.id === state.recipe.id) state.recipe.bookmarked = true;
  persistBookmarks();
}


export const deleteBookmark = function(id) {
  const index = state.bookmarks.findIndex(el => el.id === id);
  state.bookmarks.splice(index,1);
  
  //mark current recipe as not bookmarkd anymore
  if(id === state.recipe.id) state.recipe.bookmarked = false; 
  persistBookmarks();
}

const init = function() {
  const storage = localStorage.getItem(`bookmarks`);
  if(storage) state.bookmarks = JSON.parse(storage);
}
init();

const clearBookmarks = function() {
  localStorage.clear(`bookmarks`);
};
//clearBookmarks();

export const uploadRecipe = async function (newRecipe) {
  try {
    console.log(Object.entries(newRecipe));
    const ingredients = Object.entries(newRecipe)
    .filter(entry => entry[0].startsWith(`ingredient`) && entry[1] !==``)
    .map(ing => {
      const ingArray = ing[1].split(`,`).map(el => el.trim());
      if(ingArray.length !== 3) throw new Error(`Wrong ingredient format! Please use the correct one`);
      const [quantity, unit, description] = ingArray;
      return {quantity: quantity?+quantity:null, unit, description};
    });
    console.log(ingredients);
    const recipe = {
      title: newRecipe.title,
      source_url: newRecipe.sourceUrl,
      image_url: newRecipe.image,
      publisher: newRecipe.publisher,
      cooking_time: +newRecipe.cookingTime,
      servings: +newRecipe.servings,
      ingredients,
    };
    const data = await AJAX(`${API_URL}?key=${KEY}`,recipe);
    console.log(data);
    state.recipe = createRecipeObject(data);
    addBookmarks(state.recipe);
  } catch(err) {
    throw(err);
  }
  
}